/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'

const TitleBar = ({ children, componentTag, ...rest }) => {
  const Component = componentTag
  return <Component {...rest}>{children}</Component>
}

TitleBar.defaultProps = {
  componentTag: 'h1'
}

TitleBar.propTypes = {
  children: PropTypes.node,
  componentTag: PropTypes.oneOfType([PropTypes.string])
}


TitleBar.displayName = 'TitleBar'

export default TitleBar
